import { apiClient } from "@/shared/api/client";
import type { Invoice, InvoiceDetail } from "@/features/invoices/types";

export async function listMyInvoices(): Promise<Invoice[]> {
  const { data } = await apiClient.get<Invoice[]>("/invoices/me");
  return data;
}

export async function getMyInvoice(id: string): Promise<InvoiceDetail> {
  const { data } = await apiClient.get<InvoiceDetail>(`/invoices/me/${id}`);
  return data;
}
